import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  styled,
  Typography,
  useTheme,
} from '@material-ui/core';
import React from 'react';
import { useForm } from 'react-hook-form';
import CustomSelect from '../../../../components/form/CustomSelect';
import CustomInput from '../../../../components/form/CustomInput';
import { Rules } from '../../../../helpers/RHFRules';
import NumberFormatCustom from '../../../../components/form/NumberFormatCustom';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '500px',
    maxWidth: '500px',
    minHeight: '608px',
    borderRadius: '10px',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(4),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(4),
  },
  minWidth: 500,
}));

const CustomTitle = styled(Typography)(({ theme }) => ({
  ...getMulishText(700, theme.backOffice.contracts.titleForm.color, 24),
}));
const EditCertificationService = (props) => {
  const {
    openClose, products, styles, form, modifyProduct,
  } = props;

  const {
    handleSubmit,
    errors,
    control,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
  });
  const theme = useTheme();
  const setServicesToAdd = modifyProduct?.setServicesToAdd;
  const currentIndex = modifyProduct?.currentIndex;
  const setAlertInfo = openClose?.setAlertInfo;
  const isDialogOpen = openClose?.close;
  const setIsAlertOpen = openClose?.setIsAlertOpen;
  const alertStyles = styles?.alertStyles;

  const editProduct = (data) => {
    setServicesToAdd((prevServices) => prevServices.map(
      (service, index) => (index === currentIndex ? { ...service, ...data } : service),
    ));
    isDialogOpen(false);
    setAlertInfo({
      tituloModal: '¡Servicio actualizado!',
      showClose: false,
      isOnlyMessage: true,
      messageAlert: alertStyles(theme, styles?.OwnSuccesfullIcon, '508px', '284px', 65),
    });
    setIsAlertOpen(true);
    setTimeout(() => {
      setIsAlertOpen(false);
    }, 2000);
  };

  const setValidityType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'validityService') {
      setValue('validityService', value);
      setValue('validityAmount', '');
    }
    return value;
  };

  return (
    <CustomDialog open={openClose?.isOpen}>
      <DialogTitle
        style={{
          marginBottom: -20,
          marginTop: 30,
          marginLeft: 14,
        }}
        id="customized-dialog-title"
      >
        <CustomTitle>Editar servicio</CustomTitle>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomSelect
              label="Servicios"
              name="productService"
              defaultValue={products?.currentProduct?.productService}
              options={products?.listProducts}
              control={control}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <NumberFormatCustom
              label="Cantidad"
              name="quantityToAddService"
              defaultValue={products?.currentProduct?.quantityToAddService}
              control={control}
              error={errors}
              required
              rule={Rules.positiveValue}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              inputProps={{
                maxLength: 10,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              label="Tipo vigencia"
              name="validityService"
              defaultValue={products?.currentProduct?.validityService}
              options={products?.vigencyList}
              control={control}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              required
              rule={Rules.required}
              inputProps={{ onChange: (e) => setValidityType(e) }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              label="Cantidad vigencia"
              name="validityAmount"
              defaultValue={products?.currentProduct?.validityAmount}
              classes={styles.typeInput}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              control={control}
              rule={Rules.numerico}
              required
              inputProps={{
                maxLength: 9,
              }}
              onValidate={(e) => {
                if (e.target.value <= 0) {
                  setValue('validityAmount', '');
                }
                const valueTypeValidity = getValues('validityService');
                if (
                  form?.maxValidityAmount?.length > 0
                ) {
                  const valueMax = form?.maxValidityAmount?.find(
                    (maxValidity) => maxValidity.value === valueTypeValidity,
                  )?.amount;
                  if (e.target.value > valueMax) {
                    setValue('validityAmount', '');
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              label="Cupo Reasignación"
              name="reassignmentQuota"
              defaultValue={products?.currentProduct?.reassignmentQuota}
              classes={styles.typeInput}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              control={control}
              required
              inputProps={{
                maxLength: 5,
              }}
              rule={Rules.numerico}
              onValidate={(e) => {
                if (e.target.value.startsWith('0')) {
                  setValue('reassignmentQuota', '0');
                }
                if (
                  e.target.value < 0 || e.target.value > form?.reasigmentQuota
                ) {
                  setValue('reassignmentQuota', '');
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              label="Tipo de dispositivo"
              name="deviceType"
              defaultValue={products?.currentProduct?.deviceType}
              options={products?.deviceList}
              control={control}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              required
              rule={Rules.required}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              label="Tipo entrega credenciales"
              name="credentialsDeliveryType"
              defaultValue={products?.currentProduct?.credentialsDeliveryType}
              options={products?.credentialsOptions}
              control={control}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              required
              rule={Rules.required}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ paddingTop: 20 }}>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <Button
              type="button"
              variant="contained"
              color="primary"
              size="medium"
              className={styles.cancelButton}
              onClick={() => {
                isDialogOpen(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              variant="contained"
              color="primary"
              size="medium"
              className={styles.buttonStyles}
              onClick={handleSubmit(editProduct)}
            >
              Actualizar servicio
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </CustomDialog>
  );
};

export default EditCertificationService;
